import { CircularProgressbar, buildStyles  } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import React from 'react'
import LogosVersion2 from './components/Logo2'
import { Mixpanel } from '../../config/Mixpanel'
import constants from './utilities/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const Topbar = ({ showOverview, setShowOverview, lessonLength, name, lessonsCompleted, subject_name }) => {

    return (
        <div className='bg-[#1B3F63] w-full px-4 py-2 lg:py-3 lg:sticky lg:top-0 lg:z-50 flex items-center justify-between' style={{
            boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)'
        }}>
            <Link to={`/personalise/${encodeURIComponent(subject_name)}`} className='hidden lg:flex border items-center px-2 py-1 gap-3 rounded'>
                <FontAwesomeIcon icon={faArrowLeft}/>
                <p className='font-medium'>Back To Home</p>
            </Link>
            <div className='flex lg:hidden w-[50px] relative h-[50px] items-center justify-center'>
                <CircularProgressbar
                    trailWidth={12}
                    strokeWidth={12}
                    value={((lessonsCompleted ? lessonsCompleted : 0)/lessonLength)*100}
                    styles={buildStyles({pathColor: 'rgba(121, 185, 65, 1)',
                    textColor: '#f88',
                    trailColor: '#d6d6d6'
                })}/>
                <div className='absolute left-1/2 -translate-x-[50%] top-1/2 -translate-y-[50%]'>
                    <p className='text-[10px] font-medium text-center'>{lessonsCompleted ? lessonsCompleted : 0}/{lessonLength}</p>
                    <p className='text-[6px] font-medium'>{name}</p>
                </div>
            </div>
            <LogosVersion2/>
            <div className='hidden lg:flex w-[100px] h-1'></div>
            <div className="lg:hidden space-y-1.5 cursor-pointer" onClick={() => {
                Mixpanel.track(constants.Mixpanel.LESSON_PAGE_HAMBURGER_WAS_CLICKED)
                setShowOverview(!showOverview)
            }}>
                <div className="w-8 h-1 bg-white"></div>
                <div className="w-8 h-1 bg-white"></div>
                <div className="w-8 h-1 bg-white"></div>
            </div>
        </div>
    )
}

export default Topbar